/* global axios */
import ApiClient from './ApiClient';

class WebHooks extends ApiClient {
  constructor() {
    super('webhooks', { accountScoped: true });
  }

  enable(id) {
    return axios.post(`${this.url}/${id}/enable`);
  }
}

export default new WebHooks();
